// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"badge-wrapper-view_badgeWrapper__2VS7m","badge":"badge-wrapper-view_badge__1lT-y"};